//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserRegionAccessService from '@/apps/customer-insigths/services/somos1_user_region_access_service';
import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
export default {
  name: 'Somos1V2UserRegionAccessComponent',
  data: function data() {
    return {
      DIALOG_ADD: 'DIALOG_URA_ADD',
      DIALOG_EDIT: 'DIALOG_URA_EDIT',
      DIALOG_DELETE: 'DIALOG_URA_DELETE',
      // accesses: [{ email, regiones: [{ id_user_region_access, id_region }] }]
      accesses: [],
      allRegions: [],
      loadingTable: false,
      keyTable: 0,
      filter_enabled: true,
      collapse_filter: false,
      search: '',
      filterRegion: null,
      editingItem: null,
      form: {
        email: '',
        id_regions: []
      },
      emailRules: [function (v) {
        return !!v || 'Campo requerido';
      }, function (v) {
        return /.+@.+\..+/.test(v) || 'Email inválido';
      }]
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;
      this.loadingTable = true;
      Somos1DataEntryService.getRegionsList().then(function (res) {
        if (res && res.data) _this.allRegions = res.data;
      });
      UserRegionAccessService.list().then(function (res) {
        if (res && res.success) _this.accesses = res.data || [];
        _this.loadingTable = false;
      });
    },
    regionName: function regionName(id_region) {
      var r = this.allRegions.find(function (r) {
        return String(r.id_region) === String(id_region);
      });
      return r ? r.name : id_region;
    },
    resetForm: function resetForm() {
      this.form = {
        email: '',
        id_regions: []
      };
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onLimpiar: function onLimpiar() {
      this.search = '';
      this.filterRegion = null;
    },
    // --- ADD ---
    onOpenAddDialog: function onOpenAddDialog() {
      this.editingItem = null;
      this.resetForm();
      this.$refs[this.DIALOG_ADD].onOpen();
    },
    onSubmitAdd: function onSubmitAdd() {
      if (!this.$refs.formAdd.validate()) return;
      var self = this;
      var promises = self.form.id_regions.map(function (id_region) {
        return UserRegionAccessService.create(self.form.email, id_region);
      });
      Promise.all(promises).then(function () {
        self.$toast.success('Accesos agregados correctamente');
        self.$refs[self.DIALOG_ADD].onClose();
        self.keyTable += 1;
        self.loadData();
        self.$emit('refresh');
      });
    },
    // --- EDIT (calcula diff: qué agregar y qué quitar) ---
    onOpenEditDialog: function onOpenEditDialog(item) {
      this.editingItem = item;
      this.form = {
        email: item.email,
        id_regions: item.regiones.map(function (r) {
          return r.id_region;
        })
      };
      this.$refs[this.DIALOG_EDIT].onOpen();
    },
    onSubmitEdit: function onSubmitEdit() {
      if (!this.$refs.formEdit.validate()) return;
      var self = this;
      var originalIds = self.editingItem.regiones.map(function (r) {
        return r.id_region;
      });
      var newIds = self.form.id_regions;
      var toAdd = newIds.filter(function (id) {
        return originalIds.indexOf(id) === -1;
      });
      var toRemove = self.editingItem.regiones.filter(function (r) {
        return newIds.indexOf(r.id_region) === -1;
      });
      var promises = [];
      toAdd.forEach(function (id_region) {
        promises.push(UserRegionAccessService.create(self.form.email, id_region));
      });
      toRemove.forEach(function (r) {
        promises.push(UserRegionAccessService.delete(r.id_user_region_access));
      });
      if (promises.length === 0) {
        self.$refs[self.DIALOG_EDIT].onClose();
        return;
      }
      Promise.all(promises).then(function () {
        self.$toast.success('Accesos actualizados correctamente');
        self.$refs[self.DIALOG_EDIT].onClose();
        self.keyTable += 1;
        self.loadData();
        self.$emit('refresh');
      });
    },
    // --- DELETE fila (elimina todos los accesos de ese usuario) ---
    onOpenDeleteDialog: function onOpenDeleteDialog(item) {
      this.editingItem = item;
      this.$refs[this.DIALOG_DELETE].onOpen();
    },
    onConfirmDelete: function onConfirmDelete(confirmed) {
      if (confirmed) {
        var self = this;
        var promises = self.editingItem.regiones.map(function (r) {
          return UserRegionAccessService.delete(r.id_user_region_access);
        });
        Promise.all(promises).then(function () {
          self.$toast.success('Accesos eliminados correctamente');
          self.keyTable += 1;
          self.loadData();
          self.$emit('refresh');
        });
      }
      this.$refs[this.DIALOG_DELETE].onClose();
      this.editingItem = null;
    }
  },
  computed: {
    headers: function headers() {
      return [{
        value: 'email',
        text: 'Email'
      }, {
        value: 'regiones',
        text: 'Regiones',
        sortable: false
      }, {
        value: 'actions',
        text: '',
        sortable: false
      }];
    },
    filteredItems: function filteredItems() {
      var _this2 = this;
      return this.accesses.filter(function (a) {
        var matchEmail = !_this2.search || a.email && a.email.toLowerCase().includes(_this2.search.toLowerCase());
        var matchRegion = !_this2.filterRegion || a.regiones.some(function (r) {
          return String(r.id_region) === String(this.filterRegion);
        }, _this2);
        return matchEmail && matchRegion;
      });
    },
    getClassTable: function getClassTable() {
      return this.filter_enabled ? 'col-md-9 col-sm-12' : 'col-sm-12';
    }
  }
};